import cookies from 'js-cookie';
import { getLocalStorageItem, removeLocalStorageItem } from '.';
import { AG_REFERRER_KEY, AG_TRACKING_KEY } from '../hooks/useAgTrackingStorage';

const NEXT_PUBLIC_AG_URL = process.env.NEXT_PUBLIC_AG_URL || null;

export function getTrackingParams() {
  let tracking: Record<string, string> = {};

  try {
    const hostname = typeof window !== 'undefined' ? window.location.origin : NEXT_PUBLIC_AG_URL;
    const userAgent = typeof window !== 'undefined' ? window.navigator.userAgent : null;

    const agTracking = getLocalStorageItem(AG_TRACKING_KEY);
    const agReferrer = getLocalStorageItem(AG_REFERRER_KEY);
    if (agTracking) {
      const utmParams = Object.fromEntries(new URLSearchParams(agTracking));
      [
        'utm_campaign',
        'utm_medium',
        'utm_source',
        'utm_term',
        'utm_content',
        'gclid',
        'ttclid',
        'referralCode',
        'fbshare',
        'sub2'
      ].forEach((paramName) => {
        const param = utmParams[paramName];
        if (param) {
          tracking[paramName] = param;
        }
      });
    }

    const fbp = cookies.get('_fbp');
    const fbc = cookies.get('_fbc');
    const rsId = cookies.get('rl_anonymous_id');
    const ttp = cookies.get('_ttp') || cookies.get('ttp');
    const ttclid = cookies.get('ttclid');
    const irclickid = cookies.get('irclickid');
    const referralCode = cookies.get('referralCode');
    const fbShare = cookies.get('fbShare');
    const sub2 = cookies.get('sub2');

    tracking = {
      ...tracking,
      ...(agReferrer && { referrer: agReferrer }),
      ...(fbp && { fbp }),
      ...(fbc && { fbc }),
      ...(rsId && { rsId }),
      ...(ttp && { ttp }),
      ...(ttclid && { ttclid }),
      ...(irclickid && { irclickid }),
      ...(referralCode && { referralCode }),
      ...(fbShare && { fbShare }),
      ...(sub2 && { sub2 }),
      ...(hostname && { hostname }),
      ...(userAgent && { user_agent: userAgent })
    };

    return tracking;
  } catch (e) {
    return tracking;
  }
}

export function removeTrackingParams() {
  try {
    removeLocalStorageItem(AG_TRACKING_KEY);
    removeLocalStorageItem(AG_REFERRER_KEY);
    return true;
  } catch (e) {
    return false;
  }
}
